module.exports = __webpack_public_path__ + "img/gracias-1.0e7edef4.svg";